module.exports = __webpack_public_path__ + "img/0049.b24047a4.jpg";